export const COLOR_STATES = [
    { name: 'Group Colours', value: '' },
    { name: 'Split Colours', value: '' },
]

export const COLOR_TYPES = [
    { label: 'Merge Colours', value: 'merge' },
    { label: 'Split Colours', value: 'split' },
]